export default __webpack_public_path__ + "static/media/memo_doc_pdf.739392c5.svg";